document.querySelectorAll('.search-input__clear').forEach((button) => {
  button.addEventListener('click', () => {
    const container = button.closest('.search-input');
    const input = container && container.querySelector('input.search-input__input');
    if (input) {
      input.value = '';
      input.focus();
    }
  });
});
